angular.module('storefrontApp')
    .component('vcLabeledInput', {
        templateUrl: 'themes/assets/js/common-components/labeled-input.tpl.html',
        bindings: {
            value: '=',
            form: '=',
            name: '@',
            placeholder: '@',
            type: '@?',
            autocomplete: '@?',
            required: '<',
            requiredError: '@?',
            autofocus: '<',
            disabled: '=',
        },
        controller: ['$scope', function ($scope) {
            const $ctrl = this;

            // Per-instance suffix for id/for. Two <vc-address> forms (shipping and
            // billing) render together on the payment step, so an id of the field
            // NAME alone makes every billing label resolve to the shipping input
            // and leaves the billing field with no accessible name (WCAG 4.1.2).
            // $scope.$id is AngularJS's own per-scope unique value — no counter.
            $ctrl.uid = $scope.$id;

            $ctrl.validate = function () {
                $ctrl.form.$setSubmitted();
                return $ctrl.form.$valid;
            };
        }],
    });
